{
  "anasayfa": {
    "Aylık Devam Grafiği": "Maandelijkse Aanwezigheidskaart",
    "Bekleyen Anket": "In Afwachting van Enquête",
    "Doğum Günleri": "Verjaardagen",
    "Mesai İzin": "Overwerkverlof",
    "Müsait olduğunuzda lütfen bekleyen anketlerinizi tamamlayınız": "Vul uw openstaande enquêtes in wanneer u beschikbaar bent.",
    "Resmi Günler": "Officiële Feestdagen",
    "Resmi Tatil": "Openbare Vrije Dag",
    "Takvim Yükleniyor": "Kalender laden",
    "Özel Günler": "Speciale Dagen",
    "İzinler": "Verlof",
    "Proje Sayısı ve Durumları": "Aantal Projecten en Status",
    "Proje Sayısı": "Aantal Projecten",
    "Çalışma Oranı": "Werkverhouding",
    "Proje & Genel": "Project & Algemeen",
    "Proje ve Genel Saat": "Project- en Algemene Uren",
    "Performans Hariç": "Exclusief Prestaties",
    "Proje Oranı": "Projectratio",
    "Doğum Günü Yaklaşanlar": "Aankomende Verjaardagen",
    "Yaş": "Leeftijd",
    "Veri çekilirken bir hata oluştu": "Er is een fout opgetreden bij het ophalen van gegevens",
    "Bilgiler": "Informatie",
    "Takvim": "Kalender",
    "Bağlantı Arşivi": "Linkarchief",
    "Hızlı erişim için önemli bağlantılar": "Belangrijke links voor snelle toegang",
    "Dosya Arşivi": "Bestandsarchief",
    "Sistem dökümanları ve indirilebilir dosyalar": "Systeemdocumenten en downloadbare bestanden",
    "AÇ": "OPENEN",
    "Randevu Katılım Onay": "Afspraak Aanwezigheid Bevestiging",
    "Konum Bilgi Hatası": "Locatie-informatiefout",
    "Saat": "Tijd",
    "Müşteri": "Klant",
    "İşlem": "Actie",
    "Katılmadım": "Niet Aanwezig",
    "Katıldım": "Aanwezig",
    "Yaklaşan Doğum Günleri": "Aankomende Verjaardagen",
    "Bu ay kutlanacak özel günler": "Speciale dagen om deze maand te vieren",
    "Yaş Yılı": "Jaar Oud",
    "Bugün": "Vandaag",
    "Gün Kaldı": "Dagen Over",
    "Ay": "Maand",
    "Müşteri Yetki Talep": "Klant Toestemmingsverzoek",
    "On The Jobtraining": "On The Job Training",
    "One To One": "Eén Op Eén"
  }
}
